"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "caption2ClassNames", {
    enumerable: true,
    get: function() {
        return _useCaption2Stylesstyles.caption2ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Caption2"), exports);
const _useCaption2Stylesstyles = require("./useCaption2Styles.styles");
